import { render, staticRenderFns } from "./EstablishProductNew.vue?vue&type=template&id=afb5461c&scoped=true"
import script from "./EstablishProductNew.vue?vue&type=script&lang=js"
export * from "./EstablishProductNew.vue?vue&type=script&lang=js"
import style0 from "./EstablishProductNew.vue?vue&type=style&index=0&id=afb5461c&prod&lang=scss&scoped=true"
import style1 from "./EstablishProductNew.vue?vue&type=style&index=1&id=afb5461c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afb5461c",
  null
  
)

export default component.exports